import { Button, Drawer, Table, Typography } from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { UserInfo } from "../../../../context";
import { useReactToPrint } from "react-to-print";
import { PrinterOutlined } from "@ant-design/icons";
import moment from "moment";

const MerchantPODetails = ({ open, close, selectedData }) => {
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [orderDetailsList, setOrderDetailsList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  const [displayDetailsPrint, setDisplayDetailsPrint] = useState(false);

  const tableProps = {
    bordered: false,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      dataIndex: ["productpoproductinfo", "product"],
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: ["productpoproductinfo", "description"],
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      align: "right",
      render: (text) => <p>{text}</p>,
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantInvoiceDetails = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      po_number: selectedData !== null ? selectedData.po_number : "",
    };
    axios
      .get("user/merchant/spec-po-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setOrderDetailsList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData]);

  useEffect(() => {
    getMerchantInvoiceDetails();
  }, [getMerchantInvoiceDetails]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        setDisplayDetailsPrint(true);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
      setDisplayDetailsPrint(false);
    },
  });

  return (
    <Drawer
      title="Purchase Order Details"
      // width={window.innerWidth > 710 ? 710 : "100vw"}
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
      extra={
        <div>
          <Button
            type="primary"
            onClick={handlePrint}
            icon={<PrinterOutlined />}
          >
            Print
          </Button>
        </div>
      }
    >
      {selectedData !== null && (
        <>
          <div
            style={{ overflowX: "auto", padding: paddingPrint }}
            ref={componentRef}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              {displayDetailsPrint && (
                <Typography.Title style={{ marginBottom: 15 }}>
                  Purchase Order
                </Typography.Title>
              )}
              <Typography
                style={{
                  //  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                Date Created:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {orderDetailsList.ready &&
                    moment(
                      new Date(orderDetailsList.data[0].created_at)
                    ).format("LLL")}
                </span>
              </Typography>

              <Typography
                style={{
                  // fontWeight: "bold",
                  fontSize: 14,
                  textTransform: "capitalize",
                  marginBottom: 10,
                }}
              >
                P.O #:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {orderDetailsList.ready && orderDetailsList.data[0].po_number}
                </span>
              </Typography>
            </div>

            <Table
              {...tableProps}
              pagination={false}
              columns={tableColumns}
              dataSource={
                orderDetailsList.data.length > 0 ? orderDetailsList.data : []
              }
              scroll={scroll}
              rowKey={(record) => record.product_id}
            />
          </div>
        </>
      )}

      {/* <div style={{ display: "flex", marginTop: 10 }}>
        <div style={{ flexGrow: 1 }} />
        <div>
          <Button
            type="primary"
            onClick={handlePrint}
            icon={<PrinterOutlined />}
          >
            Print
          </Button>
        </div>
      </div> */}
    </Drawer>
  );
};

export default MerchantPODetails;
